import {FC, useState, useEffect} from 'react'

import {Col, Form, Modal, Row} from 'react-bootstrap'

import Api from '../../../thesis-and-dissertations/helpers/api'
import handleApiError from 'thesis-and-dissertations/helpers/handleApiError'
import {toast} from 'react-toastify'
import {useNavigate} from 'react-router-dom'
const api = new Api()

type Props = {
  showModalAddPerson: boolean
  handleShowModalAddPerson: any
  handleRefreshTeams: any
}

const AddPersonContent: FC<Props> = ({
  showModalAddPerson,
  handleShowModalAddPerson,
  handleRefreshTeams,
}) => {
  const navigate = useNavigate()
  const [showModal, setShowModal] = useState(false)
  const [errors, setErrors] = useState<any>({})
  const [isLoading, setIsLoading] = useState(false)
  const [formData, setFormData] = useState<any>({})
  const [emptyData, setEmptyData] = useState<boolean>(false)

  useEffect(() => {
    setShowModal(showModalAddPerson)
  }, [showModalAddPerson])

  const handleCloseModal = () => {
    setEmptyData(false)
    setFormData({})
    setErrors({})
    setShowModal(false)
    handleShowModalAddPerson(false)
    localStorage.removeItem('email_check')
  }

  const handleInput = (e: any, name: string) => {
    setFormData({...formData, [name]: e.target.value})
    localStorage.setItem(name, e.target.value)
    setErrors({})
    setEmptyData(false)
  }

  const profileByEmail = (e: any, keyUpAction = true) => {
    if (keyUpAction && e?.keyCode !== 13) {
      return
    }

    let emailData = e?.target?.value ? e?.target?.value : localStorage?.getItem('email_check')
    setIsLoading(true)
    api
      .profileByEmail({email: emailData})
      .then((response: any) => {
        const {data} = response?.data
        setIsLoading(false)

        if (!data?.nama_lengkap) {
          setEmptyData(true)
        }

        setFormData({
          nama_anggota: data?.nama_lengkap ?? '',
          nik: data?.NIK ?? '',
          nomor_hp: data?.no_hp_saat_ini ?? '',
          email: data?.email,
        })
      })
      .catch((error: any) => {
        setIsLoading(false)
        const {data} = error.response
        setErrors(data?.meta?.error)

        handleApiError(error, navigate)
        toast.error(data?.meta?.message)
      })
  }

  const addMember = () => {
    setIsLoading(true)
    api
      .addMember(formData)
      .then((response: any) => {
        setIsLoading(false)

        const {data} = response

        setShowModal(false)
        handleShowModalAddPerson(false)
        handleRefreshTeams(true)
        setFormData({})
        toast.success(data?.meta?.message)
      })
      .catch((error: any) => {
        setIsLoading(false)
        const {data} = error.response
        setErrors(data?.meta?.error)

        handleApiError(error, navigate)
        toast.error(data?.meta?.message)
      })
  }

  return (
    <Modal show={showModal} centered size='lg'>
      <div className='p-10'>
        <p className='h4 mt-5'>Tambahkan Anggota</p>
        <p className='mt-5'>
          Untuk memastikan proses pendaftaran anggota berjalan dengan lancar, pastikan Anda
          memasukkan email atau NIK yang terdaftar di{' '}
          <span className='fw-bold'>Pendaftaran Beasiswa</span> dan{' '}
          <span className='fw-bold'>eBeasiswa.</span>
        </p>
        <Form>
          <Row>
            <Col md={12}>
              <Form.Group className={'my-6'}>
                <Form.Label>
                  Email/NIK<i className='text-danger'>*</i>
                </Form.Label>

                <div style={{position: 'relative', width: '100%'}}>
                  <input
                    type='text'
                    className='form-control pe-5'
                    placeholder='Masukan email/NIK'
                    value={formData?.email_check}
                    onChange={(value) => handleInput(value, 'email_check')}
                    onKeyDown={profileByEmail}
                  />

                  <button
                    type='button'
                    onClick={() => profileByEmail('', false)}
                    style={{
                      position: 'absolute',
                      top: '50%',
                      right: '10px',
                      transform: 'translateY(-50%)',
                      backgroundColor: '#F95E2F',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '6px',
                      padding: '6px 14px',
                      fontWeight: 'bold',
                    }}
                  >
                    Enter
                  </button>
                </div>

                <p style={{color: '#667085', fontSize: '12px'}} className='mt-2'>
                  Tekan <span className='fw-bold'>Enter</span> setelah mengisi data untuk
                  melanjutkan.
                </p>

                {emptyData ? <p className='text-danger mt-1'>Email/NIK tidak ditemukan</p> : null}
              </Form.Group>
            </Col>

            <div>
              <div style={{border: '0.5px solid #667085'}} />
            </div>

            <Col md={12}>
              <Form.Group className={'my-6'}>
                <Form.Label>
                  Nama Anggota<i className='text-danger'>*</i>
                </Form.Label>
                <Form.Control
                  type='text'
                  disabled={true}
                  value={formData?.nama_anggota}
                  onChange={(value) => handleInput(value, 'nama_anggota')}
                  placeholder='Masukan Nama Anggota sesuai KTP'
                />
                {errors?.nama_anggota ? (
                  <p className='text-danger mt-1'>{errors?.nama_anggota}</p>
                ) : null}
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group className={'mb-6'}>
                <Form.Label>
                  Email<i className='text-danger'>*</i>
                </Form.Label>
                <Form.Control
                  type='text'
                  disabled={true}
                  value={formData?.email}
                  onChange={(value) => handleInput(value, 'email')}
                  onKeyDown={profileByEmail}
                  placeholder='Masukan Email Akun eBeasiswa'
                />
                {errors?.email ? <p className='text-danger mt-1'>{errors?.email}</p> : null}
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group className={'mb-6'}>
                <Form.Label>
                  NIK<i className='text-danger'>*</i>
                </Form.Label>
                <Form.Control
                  value={formData?.nik}
                  disabled={true}
                  placeholder='Masukan NIK sesuai KTP'
                />
                {errors?.nik ? <p className='text-danger mt-1'>{errors?.nik}</p> : null}
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group className={'mb-6'}>
                <Form.Label>
                  No. Hp<i className='text-danger'>*</i>
                </Form.Label>
                <Form.Control
                  disabled={true}
                  value={formData?.nomor_hp?.replace('+', '')}
                  onChange={(value) => handleInput(value, 'nomor_hp')}
                  placeholder='No Hp'
                />
                {errors?.nomor_hp ? <p className='text-danger mt-1'>{errors?.nomor_hp}</p> : null}
              </Form.Group>
            </Col>
          </Row>
        </Form>

        <button
          type="button"
          className='btn btn-primary btn-sm w-100 mt-3'
          style={{background: ' var(--Primary-L-500, #F95E2F)'}}
          disabled={isLoading || !formData}
          onClick={addMember}
        >
          {isLoading ? 'Loading...' : 'Simpan'}
        </button>

        <button
          type="button"
          onClick={handleCloseModal}
          className='btn btn-sm w-100 mt-3 text-primary'
          style={{border: '1px solid var(--Primary-L-500, #F95E2F)'}}
        >
          Batal
        </button>
      </div>
    </Modal>
  )
}

const AddPersonModal: FC<Props> = ({
  showModalAddPerson,
  handleShowModalAddPerson,
  handleRefreshTeams,
}) => {
  return (
    <AddPersonContent
      showModalAddPerson={showModalAddPerson}
      handleShowModalAddPerson={handleShowModalAddPerson}
      handleRefreshTeams={handleRefreshTeams}
    />
  )
}

export default AddPersonModal
